<script setup>
//import { computed } from "vue";
import { useRoute } from "vue-router";

import SidenavItem from "./SidenavItem.vue";
import SidenavItemDropdown from "../../components/SidenavItemDropdown.vue";
import router from "../../router";
import cookies from "../../assets/js/cookies.js";
import axios from "axios";
import { computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const getRoute = (n) => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[n];
};

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

const config_childs = {
  1:{
    to: "/configuracoes/categorias",
    name: t('message.menu.category', 2),
    class: getRoute(2) === 'categorias' ? 'active' : '',
    icon: 'fa-folders',
    visible: true
  },
  2:{
    to: "/configuracoes/contas",
    name: t('message.global.bank_account', 2),
    class: getRoute(2) === 'contas' ? 'active' : '',
    icon: 'fa-university',
    visible: true
  },
  3:{
    to: "/configuracoes/cartoes-de-credito",
    name: t('message.menu.credit_card', 2),
    class: getRoute(2) === 'cartoes-de-credito' ? 'active' : '',
    icon: 'fa-credit-card',
    visible: true
  },
  4:{
    to: "/configuracoes/integracoes",
    name: t('message.menu.integration', 2),
    class: getRoute(2) === 'integracoes' ? 'active' : '',
    icon: 'fa-sitemap',
    visible: cookies.get('user_agive_account_type') === 'J'
  }
}

const isMobile = () => {
  
  // check if mobile device
  const isMobileDevice = window.navigator.userAgent
    .toLowerCase()
    .includes("mobi");

  if (isMobileDevice) {
    return true;
  } else {
    return false
  }

}

const logout = () => {

  let session = cookies.get('user_agive_session');

  axios.get('/helpers/logout?session='+session)
  .then(res => {

    console.log(res);
    
    if(res.data.error){

      alert(res.data);

    }
    else{

      cookies.remove('user_agive_session');
      cookies.remove('user_agive_email');
      cookies.remove('user_agive_name');
      cookies.remove('user_agive_account_type');

      if(isMobile()){

        if(window.ReactNativeWebView){

          let message = {
            'action': 'logout'
          };

          window.ReactNativeWebView.postMessage(JSON.stringify(message));
        }

      }

      router.push({name: 'Login'});

    }

  })
  .catch(err => {
    console.error(err); 
  })

}
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item d-none d-lg-block">
        <sidenav-item
          to="/inicio"
          :class="getRoute(1) === 'dashboard-default' ? 'active' : ''"
          :navText="t('message.menu.home')"
        >
          <template v-slot:icon>
            <i class="fal fa-home text-sm opacity-10" 
                :class="darkMode ? 'text-white' : 'text-dark'"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item d-none d-lg-block">
        <sidenav-item
          to="/transacoes"
          :class="getRoute(1) === 'transacoes' ? 'active' : ''"
          :navText="t('message.global.transaction', 1)"
        >
          <template v-slot:icon>
            <i
              class="fal fa-money-bill-wave text-sm opacity-10"
              :class="darkMode ? 'text-white' : 'text-dark'"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item d-none d-lg-block">
        <sidenav-item
          to="/objetivos"
          :class="getRoute(1) === 'objetivos' ? 'active' : ''"
          :navText="t('message.global.objetive', 1)"
        >
          <template v-slot:icon>
            <i
              class="fal fa-bullseye-arrow text-sm opacity-10"
              :class="darkMode ? 'text-white' : 'text-dark'"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="cookies.get('user_agive_account_type') === 'J'">
        <sidenav-item
          to="/clientes"
          :class="getRoute(1) === 'clientes' ? 'active' : ''"
          :navText="t('message.menu.customer', 1)"
        >
          <template v-slot:icon>
            <i
              class="fal fa-users text-sm opacity-10"
              :class="darkMode ? 'text-white' : 'text-dark'"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <SidenavItemDropdown
          to="/configuracoes"
          :class="getRoute(1) === 'configuracoes' ? 'active' : ''"
          :navText="t('message.menu.configuration', 2)"
          :navChilds="config_childs"
          :collapseId="'collapse-config'"
        >
          <template v-slot:icon>
            <i class="fal fa-cogs text-sm opacity-10" :class="darkMode ? 'text-white' : 'text-dark'"></i>
          </template>
        </SidenavItemDropdown>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/minha-conta"
          :class="getRoute(1) === 'minha-conta' ? 'active' : ''"
          :navText="t('message.menu.my_account')"
        >
          <template v-slot:icon>
            <i class="fal fa-user text-sm opacity-10" :class="darkMode ? 'text-white' : 'text-dark'"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/suporte"
          :class="getRoute(1) === 'suporte' ? 'active' : ''"
          :navText="t('message.menu.support')"
        >
          <template v-slot:icon>
            <i class="fal fa-ticket-alt text-sm opacity-10" :class="darkMode ? 'text-white' : 'text-dark'"></i>
          </template>
        </sidenav-item>
      </li>
     

      <li class="nav-item">
        <a class="nav-link" type="button" @click="logout()">
          <div
                class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <i class="fal fa-sign-out text-sm opacity-10" :class="darkMode ? 'text-white' : 'text-dark'"></i>
            </div>
            <span class="nav-link-text" :class="isRTL ? ' me-1' : 'ms-1'">
              {{t('message.menu.logout')}}
            </span>
        </a>
        
      </li>

      
    </ul>
  </div>

  
</template>
